// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSE_MENU';
export const WINDOW_WIDTH = 'WINDOW-WIDTH';
export const SWITCH_LANGUAGE = 'SWITCH-LANGUAGE';

//Contact Module const
export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_ERROR = 'fetch_error';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const ON_SHOW_LOADER = 'ON_SHOW_LOADER';
export const ON_HIDE_LOADER = 'ON_HIDE_LOADER';

//Auth const
export const SIGNUP_USER = 'SIGNUP_USER';
export const SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS';
export const SIGNIN_GOOGLE_USER = 'SIGNIN_GOOGLE_USER';
export const SIGNIN_GOOGLE_USER_SUCCESS = 'SIGNIN_GOOGLE_USER_SUCCESS';
export const SIGNIN_FACEBOOK_USER = 'SIGNIN_FACEBOOK_USER';
export const SIGNIN_FACEBOOK_USER_SUCCESS = 'SIGNIN_FACEBOOK_USER_SUCCESS';
export const SIGNIN_TWITTER_USER = 'SIGNIN_TWITTER_USER';
export const SIGNIN_TWITTER_USER_SUCCESS = 'SIGNIN_TWITTER_USER_SUCCESS';
export const SIGNIN_GITHUB_USER = 'SIGNIN_GITHUB_USER';
export const SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_success';
export const SIGNIN_USER = 'SIGNIN_USER';
export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
export const SIGNOUT_USER = 'SIGNOUT_USER';
export const SIGNOUT_USER_SUCCESS = 'SIGNOUT_USER_SUCCESS';
export const VERIFY_OTP_START = "VERIFY_OTP_START";
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_ERROR = "VERIFY_OTP_ERROR";
export const INIT_URL = 'INIT_URL';
export const USER_DATA = 'user_data';
export const USER_TOKEN_SET = 'user_token_set';
export const SIGNOUT_USER_START = "SIGNOUT_USER_START";
export const SIGNOUT_USER_ERROR = 'SIGNOUT_USER_ERROR';

export const GET_SITES = 'GET_SITES';
export const GET_SITES_SUCCESS = 'GET_SITES_SUCCESS';

export const SIGNIN_USER_START = 'SIGNIN_USER_START';
export const SIGNIN_USER_ERROR = 'SIGNIN_USER_ERROR';


export const AUTH_REFRESH = 'AUTH_REFRESH';
export const AUTH_REFRESH_START = 'AUTH_REFRESH_START';
export const AUTH_REFRESH_SUCCESS = 'AUTH_REFRESH_SUCCESS';
export const AUTH_REFRESH_ERROR = 'AUTH_REFRESH_ERROR';
export const HIDE_AUTH_REFRESH_ERROR = 'HIDE_AUTH_REFRESH_ERROR';

export const AUTH_BOOTSTRAP_REQUEST = 'AUTH_BOOTSTRAP_REQUEST';
export const AUTH_BOOTSTRAP_SUCCESS = 'AUTH_BOOTSTRAP_SUCCESS';
export const AUTH_BOOTSTRAP_FAILURE = 'AUTH_BOOTSTRAP_FAILURE';

export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_START = 'FETCH_USER_START';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_ERROR = 'FETCH_USER_ERROR';

export const CLOSE_SESSION = "CLOSE_SESSION";
export const CLOSE_SESSION_START = "CLOSE_SESSION_START";
export const CLOSE_SESSION_SUCCESS = "CLOSE_SESSION_SUCCESS";
export const CLOSE_SESSION_ERROR = "CLOSE_SESSION_ERROR";

export const SET_USER_ROLE = 'SET_USER_ROLE';
export const SET_USER_SITE = "SET_USER_SITE";
export const SET_MIP_DATA = 'SET_MIP_DATA';

export const FETCH_USER_ALLOWED_RIS_WITH_MIPS = "FETCH_USER_ALLOWED_RIS_WITH_MIPS";
export const FETCH_USER_ALLOWED_RIS_WITH_MIPS_START = "FETCH_USER_ALLOWED_RIS_WITH_MIPS_START";
export const FETCH_USER_ALLOWED_RIS_WITH_MIPS_SUCCESS = "FETCH_USER_ALLOWED_RIS_WITH_MIPS_SUCCESS";
export const FETCH_USER_ALLOWED_RIS_WITH_MIPS_ERROR = "FETCH_USER_ALLOWED_RIS_WITH_MIPS_ERROR";

export const UPDATE_MIP_DATA = "UPDATE_MIP_DATA";
